import { Panel as UiPanel } from '@developerz/ui';
import type { JSX } from 'solid-js';
import { Show } from 'solid-js';

// Panel: the shared `ui-panel` (hairline border, flat fill, no shadow) with the
// canvas head row — the title left, the caller's action right, a rule under it
// — and an optional muted footer line. Callers pass the action fully rendered so
// the label + href stay theirs.
//
// `class` lands on the outer `section.panel`, because the shared primitive takes
// no `class` by design. It stays: it is the per-view stylesheets' hook
// (`.log-sink .panel__body`, `.repo-policy__section .panel__title`). The
// `card__title` / `card__content` classes beside `panel__title` / `panel__body`
// are no view rule's hook any more — only tests still query them — and no
// `.card*` rule paints them here (`ui/_card.scss` resets what would).

export function Panel(props: {
  title: string;
  action?: JSX.Element;
  footer?: string;
  class?: string;
  /** The section's id: an in-page target (the Fleet page's `#roles`, #6788). */
  id?: string;
  children?: JSX.Element;
}): JSX.Element {
  return (
    <section id={props.id} classList={{ panel: true, [props.class ?? '']: Boolean(props.class) }}>
      <UiPanel pad="sm">
        <div class="panel__head">
          <h2 class="panel__title card__title">{props.title}</h2>
          <Show when={props.action}>{props.action}</Show>
        </div>
        <div class="panel__body card__content">{props.children}</div>
        <Show when={props.footer}>
          <p class="panel__footer">{props.footer}</p>
        </Show>
      </UiPanel>
    </section>
  );
}
